/** Route builders, so the query-string shape lives in one place. */

import type { Kind } from '@sflx/shared';

export interface WatchTarget {
  accountId: string;
  kind: Kind;
  xtreamId: number;
  episodeId?: string | null;
  container?: string | null;
  /** Shown while the play URL is still being minted. */
  title?: string | null;
}

export function watchLink(target: WatchTarget): string {
  const params = new URLSearchParams({
    account: target.accountId,
    kind: target.kind,
    id: String(target.xtreamId),
  });
  if (target.episodeId) params.set('episode', target.episodeId);
  if (target.container) params.set('container', target.container);
  if (target.title) params.set('title', target.title);
  return `/watch?${params.toString()}`;
}

export function movieLink(accountId: string, xtreamId: number): string {
  return `/movies/${accountId}/${xtreamId}`;
}

export function seriesLink(accountId: string, xtreamId: number): string {
  return `/series/${accountId}/${xtreamId}`;
}

/** A free channel has no account or Xtream id, so it gets its own query shape. */
export function freeWatchLink(channelId: string, title?: string | null): string {
  const params = new URLSearchParams({ free: channelId });
  if (title) params.set('title', title);
  return `/watch?${params.toString()}`;
}
